import { UploadApiService } from './UploadApiService';
import { UploadPersistenceService } from './UploadPersistenceService';
import { UploadViewService } from './UploadViewService';
import { UploadModel } from '../models/view/Upload';
import { UploadContainerModel } from '../models/view/UploadContainer';
import { StoredFileModel } from '../models/view/StoredFile';

export class VesDamageUploadService {
	private readonly options: BasicAppOptions<VesDamageAppDefinition>;
	private readonly uploadApiService: UploadApiService<VesDamageAppDefinition>;
	private readonly uploadPersistenceService: UploadPersistenceService;
	private readonly uploadViewService: UploadViewService<VesDamageAppDefinition>;
	private readonly fileStoredClassName: string;
	private readonly errorFileValidationTypeAttr: string;
	protected uploadContainerClass: string;
	protected uploadRowClass: string;
	protected uploadFileDataClass: string;
	protected uploadClass: string;
	protected allowedExtensions: string[];


	constructor(options: BasicAppOptions<VesDamageAppDefinition>) {
		this.options = options;
		this.uploadApiService = new UploadApiService(options);
		this.uploadPersistenceService = new UploadPersistenceService(options);
		this.uploadViewService = new UploadViewService(options);

		this.fileStoredClassName = 'js-file-stored';
		this.errorFileValidationTypeAttr = 'error-file-validation-type';
		this.uploadContainerClass = '.js-upload-container';
		this.uploadRowClass = '.js-file-upload';
		this.uploadFileDataClass = '.js-data';
		this.uploadClass = '.js-upload';

		this.allowedExtensions = ['jpg', 'tif', 'tiff', 'pdf', 'jpeg', 'png', 'heic', 'webp'];
	}

	public uploadFiles(uploadElements: JQuery,
		vorgangsnummer: string,
		handleUploadResponse: (data: ApiResponse<string>, elemId: string) => void,
		handleUpdloadValidationError: (element: JQuery) => void): void {
		uploadElements.each((index, item) => {
			if (!$(item).hasClass(this.fileStoredClassName)) {
				if (this.checkFile(item)) {
					const data = new FormData();
					data.append("File", $(item).prop('files')[0]);
					this.uploadApiService.fileUpload(item.id, data, vorgangsnummer, 'schadenmeldung', handleUploadResponse, this.fileUploadError.bind(this));
				} else {
					handleUpdloadValidationError($(item));
				}
			}
		});
	}

	public deleteFile(uploadContainerId: string): void {
		const uploadContainer = $(`#${uploadContainerId}`);

		const uploads = this.uploadViewService.getUploadedDataElementsFromView(uploadContainer);
		let uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
		if (uploadModel && uploadModel.UploadContainer) {
			uploadModel.UploadContainer[uploadContainerId] = this.setStoredFilesByIdToModel(uploadContainerId, uploads);
			uploadModel = this.setCalcFileSizeSumToModel(uploadModel);

			this.uploadPersistenceService.setUploadModelToStore(uploadModel);
			this.uploadViewService.updateTotalFileSizeToView(uploadModel);
		}
	}

	private setStoredFilesByIdToModel(uploadContainerId: string, uploads: JQuery): UploadContainerModel {
		const uploadContainerModel = new UploadContainerModel();
		uploadContainerModel.Files = new Array<StoredFileModel>();
		uploadContainerModel.ContainerId = uploadContainerId;

		$(uploads).each((index, item) => {
			const storedFileModel = new StoredFileModel();
			storedFileModel.FileGuid = $(item).attr('data-js-guid');
			storedFileModel.FileSize = parseFloat($(item).attr('data-js-filesize'));
			storedFileModel.FileName = $(item).text();

			uploadContainerModel.Files.push(storedFileModel);
		});
		return uploadContainerModel;
	}

	private setCalcFileSizeSumToModel(uploadModel: UploadModel): UploadModel {
		uploadModel.FileSizeSum = 0;
		uploadModel.FileCounter = 0;
		for (const id in uploadModel.UploadContainer) {
			const container = uploadModel.UploadContainer[id];
			if (container && container.Files) {
				container.Files.forEach((storedFile) => {
					uploadModel.FileSizeSum += storedFile.FileSize;
					uploadModel.FileCounter++;
				});
			}
		}
		return uploadModel;
	}






	public updateFileView(elemId: string, data: ApiResponse<string>): void {
		const $fileElem = this.options.$ctx.find(`#${elemId}`).closest(this.uploadClass).find(this.uploadFileDataClass);
		const rowLeftElem = $fileElem.parents('.js-file-upload').first();
		this.uploadViewService.setFileStoredClass(elemId);
		$(rowLeftElem).addClass(this.fileStoredClassName);
		this.uploadPersistenceService.setUploadedFileToStore($fileElem, data.Data);

		const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
		this.uploadViewService.updateFileView($fileElem, data.Data);
		this.uploadViewService.updateFileSizeSummaryToView(this.options.$ctx, uploadModel);
	}

	public fileUploadError(): void {
		T.Utils.Helper.routeToUrl(this.options.app.errorpageurl);
	}

	private checkFile(element: JQuery | HTMLElement): boolean {
		const $elm = $(element);
		const file = $elm.prop('files')[0];
		if (file === undefined) {
			return false;
		}

		const extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLocaleLowerCase();

		if ($.inArray(extension, this.allowedExtensions) === -1) {
			$elm.attr(this.errorFileValidationTypeAttr, 'allowedFiletype');
			return false;
		}

		const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();
		let fileSizeSummary = file.size / 1024;
		if (uploadModel.FileSizeSum) {
			fileSizeSummary += uploadModel.FileSizeSum;
		}

		// 150 MB
		if (fileSizeSummary > 153600) {
			$elm.attr(this.errorFileValidationTypeAttr, 'maxFileSizeSummary');
			return false;
		}

		if (uploadModel.FileCounter > 24) {
			$elm.attr(this.errorFileValidationTypeAttr, 'maxFileCount');
			return false;
		}
		if (file.size / 1024 > 6144) {
			$elm.attr(this.errorFileValidationTypeAttr, 'maxFileSize');
			return false;
		}
		return true;
	}

	public deleteFilesByUploadContainerId(uploadContainerId: string, uploadModel: UploadModel): UploadModel {
		const model = uploadModel;
		if (model && model.UploadContainer && model.UploadContainer[uploadContainerId]) {
			model.UploadContainer[uploadContainerId].Files.forEach((value) => {
				model.FileSizeSum -= value.FileSize;
				model.FileCounter--;
			});
			delete model.UploadContainer[uploadContainerId];
		}
		return model;
	}
}
